<template>
    <div id="homePage">
        <div class="banner" v-if="!$root.isMob()">
            <el-carousel :height="bannerHeight">
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                    <img :src="API+item.url" :alt="item.title"/>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div ref="content" :class="$root.isMob() ? 'content mob' : 'content'">
            <div class="title">
                <i class="el-icon-s-platform"></i>
                <div class="tab">
                    <span :class="projectShowing=='web'?'active':''" @click="projectShowing = 'web'">数智WEB</span>     
                    <span :class="projectShowing=='vr'?'active':''" @click="projectShowing = 'vr'">数智VR</span>    
                    <div class="line"></div>
                </div>
            </div>
            <div class="type" ref="types" :style="projectShowing=='web'?'':'display:none;'">
                <div class="item active" ref="type_all" @click="type = ''">
                    <h3 v-if="!$root.isMob()">全部类型</h3>
                    <h4 v-if="$root.isMob()">全部类型</h4>
                </div>  
                <div class="item" :ref="'type_'+item.id" v-for="item in cate" :key="item.id" @click="type = item.id.toString()">
                    <h3 v-if="!$root.isMob()">{{ item.name }}</h3>
                    <h4 v-if="$root.isMob()">{{ item.name }}</h4>
                </div>                
            </div>
            <div class="type" ref="types2" :style="projectShowing=='vr'?'':'display:none;'">
                <div class="item active" ref="typeVr_all" @click="typeVr = ''">
                    <h3 v-if="!$root.isMob()">全部类型</h3>
                    <h4 v-if="$root.isMob()">全部类型</h4>
                </div>  
                <div class="item" :ref="'typeVr_'+item.id" v-for="item in cate" :key="item.id" @click="typeVr = item.id.toString()">
                    <h3 v-if="!$root.isMob()">{{ item.name }}</h3>
                    <h4 v-if="$root.isMob()">{{ item.name }}</h4>
                </div>                
            </div>
            <div class="list">
                <articleList :type = 'projectShowing=="web"?type:typeVr' :clinet="projectShowing"/>
            </div>            

            <!-- 模型展示有需要可以打开 -->
            <!-- <div class="title">                
                <i class="el-icon-s-help"></i>
                模型展示
            </div>
            <div class="list modList">
                <div class="list">
                    <modelShow :isShowDetail="true" :id="modelShow1" @showDetail="showModDetail"/>
                    <modelShow :isShowDetail="true" :id="modelShow2" v-if="!$root.isMob()" @showDetail="showModDetail"/>
                    <modelShow :isShowDetail="true" :id="modelShow3" v-if="!$root.isMob()" @showDetail="showModDetail"/>
                </div>
                <el-button type="primary" @click="isShowModList=true">查看更多</el-button>
            </div> -->
            

            <div class="title">                
                <i class="el-icon-notebook-2"></i>
                云课堂
            </div>
            <div class="type" ref="lenrnTypes">
                <div class="item active" ref="lern_type_all" @click="lernType = ''">
                    <h3 v-if="!$root.isMob()">全部类型</h3>
                    <h4 v-if="$root.isMob()">全部类型</h4>
                </div>  
                <div class="item" :ref="'lern_type_'+item.id" v-for="item in learnCate" :key="item.id" @click="lernType = item.id.toString()">
                    <h3 v-if="!$root.isMob()">{{ item.name }}</h3>
                    <h4 v-if="$root.isMob()">{{ item.name }}</h4>
                </div>                
            </div>
            <div class="list">
                <learnList :type = 'lernType'/>
            </div>

            <!-- 模型展示列表 -->
            <!-- <el-dialog
                title="模型展示"
                :visible.sync="isShowModList"
                :width="$root.isMob()?'80%':'50%'">
                <modelShowList :isHome="true" @showDetail="showModDetail"/>
            </el-dialog> -->
            
        </div>
    </div>
</template>

<script>
import articleList from '../lib/articleList.vue';
import learnList from '../lib/learnList.vue';
// import modelShow from '../lib/modelShow.vue';
// import modelShowList from '../lib/modelShowList.vue';

export default {
  name: 'homePage',
  components: {
    articleList,
    learnList,
    // modelShow,
    // modelShowList
  },
  watch: {
    "type":function(){
        this.$refs.types.querySelectorAll('.item').forEach(element => {
            element.classList.remove('active');
        });
        if(this.type != ""){
            this.$refs['type_'+this.type][0].classList.add('active');
        }
        else{
            this.$refs.type_all.classList.add('active');
        }
    },
    "typeVr":function(){
        this.$refs.types2.querySelectorAll('.item').forEach(element => {
            element.classList.remove('active');
        });
        if(this.typeVr != ""){
            this.$refs['typeVr_'+this.typeVr][0].classList.add('active');
        }
        else{
            this.$refs.typeVr_all.classList.add('active');
        }
    },
    "lernType":function(){
        this.$refs.lenrnTypes.querySelectorAll('.item').forEach(element => {
            element.classList.remove('active');
        });
        if(this.lernType != ""){
            this.$refs['lern_type_'+this.lernType][0].classList.add('active');
        }
        else{
            this.$refs.lern_type_all.classList.add('active');
        }
    },
  },
  data() {
    return {
        bannerList:[],
        cate:[],
        learnCate:[],
        lernType:'',
        type:'',
        typeVr:'',
        API:window.config.api,
        bannerHeight:"30vh",
        projectShowing:"web",
        isShowModList:false,
        modelShow1:0,
        modelShow2:1,
        modelShow3:2,
    }
  },
  methods: {
    showModDetail(id){
        this.$router.replace({
            path:"/modelDetail",
            query:{
                id:id
            }
        })
    },
    async getData(){
        let bannerList = await this.$root.getBanner();
        let cate = await this.$root.getDjCate();
        let learnCate = await this.$root.getLearnCate();
        this.cate = cate.data;
        this.learnCate = learnCate.data;
        this.bannerList = bannerList;
    },
    changeBannerSize(){
        if(!this.$root.isMob()){
            let windowWidth = window.innerWidth;
            //保留两位小数
            this.bannerHeight = Math.floor(windowWidth / 3.84 * 100) / 100 + "px";
            this.$nextTick(()=>{
                this.$refs.content.style.marginTop = this.bannerHeight;
            })
        }
    },
  },
  created() {
    this.changeBannerSize();
    this.getData();
  }
}
</script>

<style scoped lang="scss" src="@/assets/css/homePage.scss"></style>